import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface UploadStateInterface {
  openMultiFileUpload: boolean,
}

const initialState: UploadStateInterface = {
  openMultiFileUpload: false,
}

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setOpenMultiFileUpload(state, action: PayloadAction<boolean>) {
      state.openMultiFileUpload = action.payload
    },
    clearData(state) {
      state = { ...initialState }
    },
  },
})

export const {
  setOpenMultiFileUpload,
  clearData,
} = uploadSlice.actions
export default uploadSlice.reducer
